var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.35355 9.64645L6 9.29289L5.64645 9.64645L3.64645 11.6464L3.29289 12L3.64645 12.3536L9.64645 18.3536L10 18.7071L10.3536 18.3536L21.0202 7.68689L21.3738 7.33333L21.0202 6.97978L19.0202 4.97978L18.6667 4.62623L18.3131 4.97978L10 13.2929L6.35355 9.64645ZM23.5 12C23.5 18.3513 18.3513 23.5 12 23.5C5.6487 23.5 0.5 18.3513 0.5 12C0.5 5.6487 5.6487 0.5 12 0.5C18.3513 0.5 23.5 5.6487 23.5 12Z",
    fill: "#008000",
    stroke: "#008000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/Success.8af06091a35fe470697816c5db30b30a.svg";
export { ForwardRef as ReactComponent };